import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import PdfViewer from "../components/PdfViewer";

import SESSION_PDF from '../images/CamScanner 01.06.2026 12.37.pdf';


const Session = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>{t("session")} - Gordito Plus</title>
      </Helmet>
      <PdfViewer src={SESSION_PDF} title={t("session")} />
    </div>
  );
};

export default Session;
